<script setup>
// ============================================================================
// BonBoZ: LỌC NHANH ở thanh trái — ba nút, mỗi nút mở một bảng chọn.
//
// Bản đầu bày cả bảy bộ lọc thành bảy biểu tượng 16px xếp dọc. Nhìn vừa nhỏ
// vừa rời rạc, mà biểu tượng không nhãn thì không ai đoán ra "hình cái thẻ" là
// lọc chưa gắn nhãn hay lọc theo tag. Gộp lại còn BA nút to (36px, biểu tượng
// 20px); chi tiết nằm trong bảng chọn có CHỮ, đúng cách Retion làm.
//
// Nút nào đang có bộ lọc bật thì mang một chấm nhỏ — nhìn phát biết danh sách
// đang bị thu hẹp, khỏi phải mở từng bảng ra dò.
//
// Số đếm chỉ hiện ở hai mục server có trả về (của tôi, chưa phân công). Bịa số
// cho các mục còn lại thì tệ hơn là để trống.
// ============================================================================
import { computed, ref, nextTick, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { onClickOutside, useMediaQuery } from '@vueuse/core';
import TeleportWithDirection from 'dashboard/components-next/TeleportWithDirection.vue';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useMapGetter } from 'dashboard/composables/store';
import { emitter } from 'shared/helpers/mitt';
import {
  NHOM_LOC,
  SU_KIEN_LOC,
  SU_KIEN_DUNG_LAI,
  docTruyVan,
  truyVanKhoang,
  nhomTheoNhan,
  nhomTheoNhanVien,
} from 'dashboard/helper/quickFilters';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import DateRangeFilter from 'dashboard/components/DateRangeFilter/DateRangeFilter.vue';
import { DATE_FILTER_MODES } from 'dashboard/composables/useDateFilterMode';

// `ngang`: ban dat trong cot danh sach hoi thoai tren DIEN THOAI. Thanh trai
// (noi ban doc song) bi an duoi 768px, ma day la cho duy nhat loc duoc "chua
// phan cong" / theo tag / theo ngay — thieu no thi truc page tren dien thoai
// chi xem duoc hang "tat ca".
//
// Ban ngang khac ban doc hai diem: nut xep hang va CO CHU (khong ai doan ra
// bieu tuong khi khong ro chuot duoc), va bang chon bung XUONG rong bang man
// thay vi nam canh nut. Rieng bang lich thi chiem tron man hinh, xem
// `isNarrowScreen`.
const props = defineProps({
  ngang: { type: Boolean, default: false },
});

const route = useRoute();
const router = useRouter();
const { isAdmin } = useAdmin();
const accountId = useMapGetter('getCurrentAccountId');
const soLieu = useMapGetter('conversationStats/getStats');
const cacNhan = useMapGetter('labels/getLabels');
const cacNhanVien = useMapGetter('agents/getAgents');

const nhomDangMo = ref('');
// Toa do nut vua bam. Bang chon PHAI teleport ra ngoai: the <nav> boc thanh
// trai co `overflow-y-scroll`, bang chon dat tuyet doi ben trong bi CAT mat -
// bam thi state doi nhung khong thay gi. Chatwoot cung phai lam vay cho popover
// cua rail (SidebarCollapsedPopover + TeleportWithDirection).
const toaDo = ref({ top: 0, left: 0, right: 0 });
const bangRef = ref(null);
const moLich = ref(false);

// Lua chon cua lan mo truoc. Mo lai bang lich ma thay no tro ve mac dinh thi
// moi lan chinh khoang la mot lan chon lai tu dau.
const dateRange = ref([]);
const dateTimeRange = ref([]);
const dateMode = ref(DATE_FILTER_MODES.UPDATED);

// Duoi 768px bang lich chiem tron man hinh chu khong neo theo nut nua. Dung
// dung `ngang` thay cho do nay: cua so may tinh hep cung can ban toan man, con
// `ngang` chi noi len rang thanh loc dang nam trong cot hoi thoai.
const isNarrowScreen = useMediaQuery('(max-width: 767px)');
const nutRef = ref({});
const isRTL = useMapGetter('accounts/isRTL');

// Ham ref chu KHONG phai `ref="bangRef"`: the nay nam trong v-for nen string
// ref se cho ra MOT MANG, va onClickOutside kiem `contains` tren mang thi luon
// sai -> bam ra ngoai khong dong.
const datBangRef = el => {
  bangRef.value = el;
};

// `ignore`: bam lai chinh nut dang mo thi de moNhom() xu ly viec dong. Thieu
// no thi mot cu bam vua dong (click-outside) vua mo lai -> bang KHONG BAO GIO
// dong duoc bang cach bam lai nut.
//
// PHAI la mot HAM tra ve mang, khong phai mang chua ham. vueuse duyet tung
// phan tu cua `ignore` roi goi `unrefElement` len no; phan tu la ham tra ve
// MANG thi ket qua khong co `.contains`, danh sach bo qua coi nhu rong va cu
// bam thu hai vua dong vua mo lai. Loi im lang - khong canh bao, khong ngoai le.
// Co tu truoc va dinh ca ban doc lan ban ngang; do duoc 09/09/2026.
onClickOutside(
  bangRef,
  () => {
    nhomDangMo.value = '';
    moLich.value = false;
  },
  { ignore: () => Object.values(nutRef.value).filter(Boolean) }
);

// Chieu cao toi da cua bang lich. Dung de GHIM dinh bang lai: neo thang theo
// nut thi nut o nua duoi man se day bang lich xuong duoi day va bi cat mat nut
// Ap dung — do duoc 29/09/2026.
const CALENDAR_PANEL_HEIGHT = 540;

const viTriLich = computed(() => {
  const { top, left, right } = toaDo.value;
  const dinhToiDa = Math.max(8, window.innerHeight - CALENDAR_PANEL_HEIGHT - 8);
  const dinh = `${Math.min(top, dinhToiDa)}px`;
  return isRTL.value
    ? { top: dinh, right: `${window.innerWidth - left + 8}px` }
    : { top: dinh, left: `${right + 8}px` };
});

const viTri = computed(() => {
  const { top, bottom, left, right } = toaDo.value;
  // Ban ngang: bang bung XUONG duoi nut va cang gan het be ngang man. Giu kieu
  // "canh phai nut" nhu ban doc thi nut o cuoi hang se day bang ra ngoai man.
  if (props.ngang) return { top: `${bottom + 8}px`, left: '8px', right: '8px' };

  return isRTL.value
    ? { top: `${top}px`, right: `${window.innerWidth - left + 8}px` }
    : { top: `${top}px`, left: `${right + 8}px` };
});
// Một lúc chỉ một bộ lọc: nhiều cái chồng nhau thì không ai đoán được vì sao
// danh sách trống. RIÊNG tag thì chọn được nhiều cái cùng lúc (xem tagDaChon).
const dangBat = ref('');

// Tag chọn được NHIỀU: trực page hay lọc kiểu "cần-hr + đã có sđt" hoặc
// "dv_btox hoặc dv_filler". Hai chế độ:
//   'va'   — hội thoại phải mang ĐỦ mọi tag đã chọn
//   'hoac' — mang BẤT KỲ tag nào trong số đã chọn (mặc định, hay dùng hơn)
const tagDaChon = ref(new Set());
const cheDoTag = ref('hoac');

// Ca cum tag gui len thanh MOT truy van. `label_match` quyet dinh VA hay HOAC;
// luat o `ConversationFinder#filter_by_labels`.
const truyVanTag = () => {
  const ds = [...tagDaChon.value];
  if (!ds.length) return null;
  return { labels: ds, labelMatch: cheDoTag.value === 'va' ? 'all' : 'any' };
};

// Gui bo loc tag hien tai xuong danh sach hoi thoai. Ten co dinh 'tag-nhieu'
// de nut sang dung.
const guiLocTag = () => {
  const truyVan = truyVanTag();
  if (truyVan) dangBat.value = '';
  emitter.emit(SU_KIEN_LOC, {
    kieu: 'server',
    ten: truyVan ? 'tag-nhieu' : '',
    truyVan,
  });
};

const doiCheDoTag = che => {
  cheDoTag.value = che;
  if (tagDaChon.value.size) guiLocTag();
};

const xoaChonTag = () => {
  tagDaChon.value = new Set();
  guiLocTag();
};

// Hai nhom cuoi dung du lieu DONG (nhan, nhan vien cua tai khoan) nen phai
// dung o day chu khong khai cung duoc trong locNhanh.js.
const nhomDong = computed(() => [
  nhomTheoNhan(cacNhan.value || []),
  nhomTheoNhanVien(cacNhanVien.value || []),
]);

const mucHienDuoc = m => !m.chiAdmin || isAdmin.value;

const cacNhom = computed(() =>
  [...NHOM_LOC, ...nhomDong.value]
    .map(nhom => ({
      ...nhom,
      muc: nhom.muc
        .filter(mucHienDuoc)
        .map(m => ({ ...m, soLuong: m.dem ? soLieu.value?.[m.dem] : null })),
    }))
    .filter(nhom => nhom.muc.length || nhom.kieuNhom === 'lich')
);

// `route?.name`: component nay song trong vo app, render truoc ca luc router
// san sang trong vai truong hop. Thieu dau ? la nem loi giua luc render, ma loi
// o vo app thi TRANG CA MAN HINH chu khong phai hong mot nut.
const dangSang = m => {
  if (m.kieu === 'route') return route?.name === m.route;
  if (m.laTag) return tagDaChon.value.has(m.tag);
  return dangBat.value === m.ten;
};

const nhomDangLoc = nhom =>
  nhom.kieuNhom === 'lich'
    ? dangBat.value === 'khoang-ngay'
    : nhom.muc.some(dangSang);

const chon = m => {
  // Tag: bat/tat trong danh sach da chon, khong thay the bo loc dang co
  if (m.laTag) {
    const next = new Set(tagDaChon.value);
    if (next.has(m.tag)) next.delete(m.tag);
    else next.add(m.tag);
    tagDaChon.value = next;
    guiLocTag();
    return;
  }

  const tat = dangSang(m);
  // KHONG dong bang chon o day: nguoi dung thuong tick vai muc lien tiep, dong
  // sau moi lan tick la phai mo lai tu dau. Bang tu dong khi bam ra ngoai
  // (onClickOutside) hoac bam lai chinh nut mo no.

  if (m.kieu === 'route') {
    dangBat.value = '';
    emitter.emit(SU_KIEN_LOC, { kieu: 'server', ten: '' });
    // Doi route nhung KHONG dong bang: thanh trai song xuyen suot cac route
    // nen bang van dung cho, nguoi dung tick tiep muc khac duoc ngay.
    router.push({
      name: tat ? 'home' : m.route,
      params: { accountId: accountId.value },
    });
    return;
  }

  dangBat.value = tat ? '' : m.ten;
  // Doi sang bo loc khac -> bo chon tag, neu khong hai bo loc chong nhau ma
  // giao dien chi sang mot cho.
  if (tagDaChon.value.size) tagDaChon.value = new Set();

  if (m.kieu === 'nguoi') {
    emitter.emit(SU_KIEN_LOC, {
      kieu: 'nguoi',
      giaTri: tat ? 'all' : m.giaTri,
    });
    return;
  }
  // Nut cua nhom dong (theo nhan / theo nhan vien) khong nam trong NHOM_LOC nen
  // ChatList khong tu tra duoc dieu kien -> gui thang truy van di cung.
  emitter.emit(SU_KIEN_LOC, {
    kieu: 'server',
    ten: tat ? '' : m.ten,
    truyVan: tat ? null : docTruyVan(m),
  });
};

const apDungKhoang = ({ from, to, mode, range, timeRange }) => {
  moLich.value = false;
  dateRange.value = range;
  dateTimeRange.value = timeRange;
  dateMode.value = mode;
  dangBat.value = 'khoang-ngay';
  if (tagDaChon.value.size) tagDaChon.value = new Set();
  emitter.emit(SU_KIEN_LOC, {
    kieu: 'server',
    ten: 'khoang-ngay',
    truyVan: truyVanKhoang(from, to, mode),
  });
};

const xoaKhoang = () => {
  moLich.value = false;
  dangBat.value = '';
  emitter.emit(SU_KIEN_LOC, { kieu: 'server', ten: '' });
};

const doToaDo = ten => {
  const nut = nutRef.value[ten];
  if (!nut) return;
  const r = nut.getBoundingClientRect();
  toaDo.value = { top: r.top, bottom: r.bottom, left: r.left, right: r.right };
};

// Danh sach hoi thoai dung lai tu dau: tat het cho khop, khong ban lenh loc
// nguoc xuong vi ben do von da sach.
const dungLai = () => {
  dangBat.value = '';
  if (tagDaChon.value.size) tagDaChon.value = new Set();
  dateRange.value = [];
  dateTimeRange.value = [];
  moLich.value = false;
};

emitter.on(SU_KIEN_DUNG_LAI, dungLai);
onUnmounted(() => emitter.off(SU_KIEN_DUNG_LAI, dungLai));

const moNhom = async nhom => {
  // Nhom lich khong co bang chon trung gian: bam mot cai la ra thang lich.
  if (nhom.kieuNhom === 'lich') {
    const dong = moLich.value;
    nhomDangMo.value = '';
    doToaDo(nhom.ten);
    moLich.value = !dong;
    return;
  }

  const dong = nhomDangMo.value === nhom.ten;
  nhomDangMo.value = dong ? '' : nhom.ten;
  moLich.value = false;
  if (dong) return;
  await nextTick();
  doToaDo(nhom.ten);
};
</script>

<template>
  <div
    :class="
      ngang
        ? 'flex flex-row items-center gap-2 px-3 pb-2 overflow-x-auto'
        : 'flex flex-col items-center gap-1.5 pb-3'
    "
  >
    <div v-for="nhom in cacNhom" :key="nhom.ten" :class="ngang && 'shrink-0'">
      <button
        :ref="el => (nutRef[nhom.ten] = el)"
        v-tooltip.right="ngang ? '' : $t(nhom.nhan)"
        :aria-label="$t(nhom.nhan)"
        :aria-expanded="nhomDangMo === nhom.ten"
        class="bonboz-nut-loc relative flex items-center rounded-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-n-brand"
        :class="[
          ngang ? 'h-9 gap-1.5 px-3' : 'justify-center size-11',
          nhomDangLoc(nhom)
            ? 'bg-n-brand/[0.12] text-n-brand'
            : nhomDangMo === nhom.ten
              ? 'bg-n-alpha-2 text-n-slate-12'
              : 'bg-n-alpha-1 text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12',
        ]"
        @click="moNhom(nhom)"
      >
        <span
          :class="[nhom.icon, ngang ? 'size-4' : 'size-6']"
          aria-hidden="true"
        />
        <!-- Ban ngang phai co CHU: khong ro chuot duoc thi bieu tuong khong noi
             len duoc "Cua ai" khac "Theo nhan vien" cho nao. -->
        <span v-if="ngang" class="text-sm whitespace-nowrap">
          {{ $t(nhom.nhan) }}
        </span>
        <!-- Chấm báo: nhóm này đang có bộ lọc bật -->
        <span
          v-if="nhomDangLoc(nhom) && !ngang"
          class="absolute top-1.5 right-1.5 size-2 rounded-full bg-n-brand ring-2 ring-n-solid-1"
        />
      </button>

      <TeleportWithDirection v-if="nhomDangMo === nhom.ten">
        <div
          :ref="datBangRef"
          :style="viTri"
          class="bonboz-bang-chon fixed z-50 max-h-[70vh] overflow-y-auto p-1.5 rounded-xl border border-n-weak bg-n-solid-2 shadow-xl"
          :class="ngang || 'w-64'"
        >
          <p class="px-2 py-1 m-0 text-xs font-medium text-n-slate-11">
            {{ $t(nhom.nhan) }}
          </p>

          <!-- Nhom tag: chon nhieu tag, ket hop bang VA / HOAC -->
          <div
            v-if="nhom.ten === 'theo-nhan'"
            class="flex items-center gap-1 px-2 pb-1.5"
          >
            <button
              v-for="che in ['hoac', 'va']"
              :key="che"
              class="flex-1 rounded-md px-2 py-1 text-xs transition-colors"
              :class="
                cheDoTag === che
                  ? 'bg-n-brand text-white'
                  : 'bg-n-alpha-1 text-n-slate-11 hover:bg-n-alpha-2'
              "
              @click="doiCheDoTag(che)"
            >
              {{
                che === 'va'
                  ? $t('BONBOZ.LOC_NHANH.TAG_VA')
                  : $t('BONBOZ.LOC_NHANH.TAG_HOAC')
              }}
            </button>
            <button
              v-if="tagDaChon.size"
              class="rounded-md px-2 py-1 text-xs text-n-slate-11 hover:bg-n-alpha-2"
              @click="xoaChonTag"
            >
              {{ $t('BONBOZ.LOC_NHANH.TAG_XOA') }}
            </button>
          </div>
          <p
            v-if="nhom.ten === 'theo-nhan' && tagDaChon.size > 1"
            class="px-2 pb-1 m-0 text-xxs leading-4 text-n-slate-10"
          >
            {{
              cheDoTag === 'va'
                ? $t('BONBOZ.LOC_NHANH.TAG_GIAI_THICH_VA', {
                    n: tagDaChon.size,
                  })
                : $t('BONBOZ.LOC_NHANH.TAG_GIAI_THICH_HOAC', {
                    n: tagDaChon.size,
                  })
            }}
          </p>
          <button
            v-for="m in nhom.muc"
            :key="m.ten"
            class="flex items-center w-full gap-2 px-2 py-1.5 rounded-lg text-sm text-start transition-colors hover:bg-n-alpha-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
            :class="
              dangSang(m)
                ? 'bg-n-brand/[0.10] font-medium text-n-slate-12'
                : 'text-n-slate-11'
            "
            @click="chon(m)"
          >
            <!-- Muc cua nhom dong mang mau nhan hoac anh nhan vien thay cho icon -->
            <span
              v-if="m.mau"
              class="size-3 shrink-0 rounded-sm"
              :style="{ backgroundColor: m.mau }"
              aria-hidden="true"
            />
            <Avatar
              v-else-if="m.nhanTho"
              :src="m.anh"
              :name="m.nhanTho"
              :size="18"
              rounded-full
              class="shrink-0"
            />
            <span
              v-else
              :class="m.icon"
              class="size-[18px] shrink-0"
              aria-hidden="true"
            />
            <span class="flex-1 truncate">
              {{ m.nhanTho || $t(m.nhan) }}
            </span>
            <span v-if="m.soLuong" class="text-xs text-n-slate-11 tabular-nums">
              {{ m.soLuong }}
            </span>
            <span
              v-if="dangSang(m)"
              class="i-lucide-check size-4 shrink-0 text-n-brand"
              aria-hidden="true"
            />
          </button>
        </div>
      </TeleportWithDirection>

      <TeleportWithDirection v-if="moLich">
        <div
          :ref="datBangRef"
          :style="isNarrowScreen ? null : viTriLich"
          class="fixed z-50 shadow-xl bonboz-bang-chon"
          :class="
            isNarrowScreen
              ? 'inset-0'
              : 'rounded-xl border border-n-weak max-h-[calc(100vh-1rem)] overflow-y-auto'
          "
        >
          <DateRangeFilter
            :range="dateRange"
            :mode="dateMode"
            :time-range="dateTimeRange"
            @apply="apDungKhoang"
            @clear="xoaKhoang"
            @close="moLich = false"
          />
        </div>
      </TeleportWithDirection>
    </div>
  </div>
</template>
